import { useRouteError } from 'react-router-dom';
import { ErrorPage } from './ErrorPage';

export const RouteErrorBoundary = () => {
	const error = useRouteError();

	const e = error as Error | undefined;

	return (
		<ErrorPage message={e?.message ?? 'Catched with RouteErrorBoundary'} />
	);
};
